
<template>
	<aside class="d-none d-md-block">
		<div class="d-flex align-items-center justify-content-between">
			<h2 class="text-s-m font-normal mt-2 px-3 text-nowrap">Dynamic Players</h2>
			<b-button @click="showAddPlayerModal" size="md" variant="icon">
				<svg class="text-dark-7" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M4.9999 0.150391H4.97411C4.29592 0.150385 3.75045 0.150381 3.30905 0.186444C2.85506 0.223536 2.4586 0.301749 2.09253 0.488271C1.50923 0.785478 1.03499 1.25972 0.737783 1.84302C0.55126 2.20909 0.473048 2.60555 0.435956 3.05954C0.399892 3.50093 0.399897 4.04641 0.399902 4.72459V4.75039V8.25039V8.27619C0.399897 8.95437 0.399892 9.49985 0.435956 9.94125C0.473048 10.3952 0.55126 10.7917 0.737783 11.1578C1.03499 11.7411 1.50923 12.2153 2.09253 12.5125C2.4586 12.699 2.85506 12.7772 3.30905 12.8143C3.75045 12.8504 4.29593 12.8504 4.97411 12.8504H4.97412H4.9999H10.9999H11.0257H11.0257C11.7039 12.8504 12.2494 12.8504 12.6908 12.8143C13.1447 12.7772 13.5412 12.699 13.9073 12.5125C14.4906 12.2153 14.9648 11.7411 15.262 11.1578C15.4485 10.7917 15.5268 10.3952 15.5638 9.94125C15.5999 9.49985 15.5999 8.95437 15.5999 8.27618V8.27617V8.25039V4.75039V4.72461V4.7246C15.5999 4.04641 15.5999 3.50094 15.5638 3.05954C15.5268 2.60555 15.4485 2.20909 15.262 1.84302C14.9648 1.25972 14.4906 0.785478 13.9073 0.488271C13.5412 0.301749 13.1447 0.223536 12.6908 0.186444C12.2494 0.150381 11.7039 0.150385 11.0257 0.150391H10.9999H4.9999ZM2.63732 1.55748C2.80603 1.47152 3.02699 1.41349 3.40677 1.38246C3.79355 1.35086 4.28994 1.35039 4.9999 1.35039H10.9999C11.7099 1.35039 12.2063 1.35086 12.593 1.38246C12.9728 1.41349 13.1938 1.47152 13.3625 1.55748C13.72 1.73964 14.0107 2.0303 14.1928 2.38781C14.2788 2.55652 14.3368 2.77748 14.3678 3.15725C14.3994 3.54404 14.3999 4.04043 14.3999 4.75039V8.25039C14.3999 8.96036 14.3994 9.45675 14.3678 9.84353C14.3368 10.2233 14.2788 10.4443 14.1928 10.613C14.0107 10.9705 13.72 11.2611 13.3625 11.4433C13.1938 11.5293 12.9728 11.5873 12.593 11.6183C12.2063 11.6499 11.7099 11.6504 10.9999 11.6504H4.9999C4.28994 11.6504 3.79355 11.6499 3.40677 11.6183C3.02699 11.5873 2.80603 11.5293 2.63732 11.4433C2.27981 11.2611 1.98915 10.9705 1.80699 10.613C1.72103 10.4443 1.663 10.2233 1.63197 9.84353C1.60037 9.45675 1.5999 8.96036 1.5999 8.25039V4.75039C1.5999 4.04042 1.60037 3.54404 1.63197 3.15725C1.663 2.77748 1.72103 2.55652 1.80699 2.38781C1.98915 2.0303 2.27981 1.73964 2.63732 1.55748ZM8.6 3.50037C8.6 3.169 8.33137 2.90037 8 2.90037C7.66863 2.90037 7.4 3.169 7.4 3.50037V5.90037H4.5C4.16863 5.90037 3.9 6.169 3.9 6.50037C3.9 6.83174 4.16863 7.10037 4.5 7.10037H7.4V9.50037C7.4 9.83174 7.66863 10.1004 8 10.1004C8.33137 10.1004 8.6 9.83174 8.6 9.50037V7.10037H11.5C11.8314 7.10037 12.1 6.83174 12.1 6.50037C12.1 6.169 11.8314 5.90037 11.5 5.90037H8.6V3.50037Z" fill="currentColor"/>
				</svg>
			</b-button>
		</div>
		<b-nav vertical class="mw-100 mb-3">
			<b-nav-item class="mw-100" link-classes="nav-link-dark-8 text-s-s d-flex align-items-center px-3 rounded"
				v-for="(item, index) in dynamicPlayersSorted"  :key="index" :active="activeRoute(item._id)" @click="changeRoute(item._id)">
				<svg class="mr-2 flex-shrink-0" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M4.9999 0.650391H4.97411C4.29592 0.650385 3.75045 0.650381 3.30905 0.686444C2.85506 0.723536 2.4586 0.801749 2.09253 0.988271C1.50923 1.28548 1.03499 1.75972 0.737783 2.34302C0.55126 2.70909 0.473048 3.10555 0.435956 3.55954C0.399892 4.00093 0.399897 4.54641 0.399902 5.22459V5.25039V8.75039V8.77619C0.399897 9.45437 0.399892 9.99985 0.435956 10.4412C0.473048 10.8952 0.55126 11.2917 0.737783 11.6578C1.03499 12.2411 1.50923 12.7153 2.09253 13.0125C2.4586 13.199 2.85506 13.2772 3.30905 13.3143C3.75045 13.3504 4.29593 13.3504 4.97411 13.3504H4.97412H4.9999H10.9999H11.0257H11.0257C11.7039 13.3504 12.2494 13.3504 12.6908 13.3143C13.1447 13.2772 13.5412 13.199 13.9073 13.0125C14.4906 12.7153 14.9648 12.2411 15.262 11.6578C15.4485 11.2917 15.5268 10.8952 15.5638 10.4412C15.5999 9.99985 15.5999 9.45437 15.5999 8.77618V8.77617V8.75039V5.25039V5.22461V5.2246C15.5999 4.54641 15.5999 4.00094 15.5638 3.55954C15.5268 3.10555 15.4485 2.70909 15.262 2.34302C14.9648 1.75972 14.4906 1.28548 13.9073 0.988271C13.5412 0.801749 13.1447 0.723536 12.6908 0.686444C12.2494 0.650381 11.7039 0.650385 11.0257 0.650391H10.9999H4.9999ZM2.63732 2.05748C2.80603 1.97152 3.02699 1.91349 3.40677 1.88246C3.79355 1.85086 4.28994 1.85039 4.9999 1.85039H10.9999C11.7099 1.85039 12.2063 1.85086 12.593 1.88246C12.9728 1.91349 13.1938 1.97152 13.3625 2.05748C13.72 2.23964 14.0107 2.5303 14.1928 2.88781C14.2788 3.05652 14.3368 3.27748 14.3678 3.65725C14.3994 4.04404 14.3999 4.54043 14.3999 5.25039V8.75039C14.3999 9.46036 14.3994 9.95675 14.3678 10.3435C14.3368 10.7233 14.2788 10.9443 14.1928 11.113C14.0107 11.4705 13.72 11.7611 13.3625 11.9433C13.1938 12.0293 12.9728 12.0873 12.593 12.1183C12.2063 12.1499 11.7099 12.1504 10.9999 12.1504H4.9999C4.28994 12.1504 3.79355 12.1499 3.40677 12.1183C3.02699 12.0873 2.80603 12.0293 2.63732 11.9433C2.27981 11.7611 1.98915 11.4705 1.80699 11.113C1.72103 10.9443 1.663 10.7233 1.63197 10.3435C1.60037 9.95675 1.5999 9.46036 1.5999 8.75039V5.25039C1.5999 4.54042 1.60037 4.04404 1.63197 3.65725C1.663 3.27748 1.72103 3.05652 1.80699 2.88781C1.98915 2.5303 2.27981 2.23964 2.63732 2.05748ZM10.2469 7.00039L6.5999 8.98967V5.01112L10.2469 7.00039ZM7.02664 3.87698C6.29363 3.47715 5.3999 4.0077 5.3999 4.84266V9.15812C5.3999 9.99309 6.29363 10.5236 7.02664 10.1238L10.9825 7.96608C11.7468 7.54916 11.7468 6.45162 10.9825 6.03471L7.02664 3.87698Z" fill="currentColor"/>
				</svg>
				<span class="flex-shrink-1 flex-grow-0 text-truncate">{{ item.name }}</span>
			</b-nav-item>
		</b-nav>
		<add-dynamic-player-modal @player-added="onNewPlayer" />
	</aside>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import AddDynamicPlayerModal from "@/components/modals/AddDynamicPlayerModal.vue"

export default {
	name: 'DynamicNav',
	components: {
		AddDynamicPlayerModal
	},
	props: {
		
	},
	data() {
		return {
			
		}
	},
	computed: {
		...mapGetters({
			loadingStatus: "Ui/loadingStatus",
			dynamicPlayers: "DynamicPlayers/dynamicPlayers",
		}),
		dynamicPlayersSorted: {
			get() {
				const players = _.cloneDeep(this.dynamicPlayers)
				return players.sort(function (a, b) {
					return new Date(b.creationTime) - new Date(a.creationTime)
				})
			},
			set() {
				return
			}
		}
	},
	async mounted() {
		
	},
	methods: {
		showAddPlayerModal() {
      // if(!this.checkManagePermissions()) return;
      this.$bvModal.show('modal-add-dynamic-player');
    },
		activeRoute(id) {
			if (this.$route.params && this.$route.params.playerId === id) {
				return true
			} else return false
		},
		async changeRoute(id) {
			// this.$emit('route-change', id)
			if (this.$route.params.playerId != id) {
				await this.$store.dispatch('DynamicPlayers/setCurrentPlayer', id);
				await this.$store.dispatch('DynamicPlayers/getPlayer', id);
				this.$router.push({
					name: "DynamicManage",
					params: { playerId: id },
				});
			}
		},
		async onNewPlayer(id) {
      await this.$store.dispatch('DynamicPlayers/getPlayers');
			this.changeRoute(id)
    }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
